import React, { useCallback } from "react";
import { Nav, THEMES } from "@bloomberg/media-ui-nav";
import {
    type BannerData,
    type MenuItems,
} from "@bloomberg/media-ui-nav/dist/types";
import { useNav } from "@foundation/nav";

import { Tracker } from "~utils/tracker";

import styles from "./Nav.module.css";

const tracker = new Tracker({
    category: "nav",
});

const bannersTracker = new Tracker({
    category: "banners",
});

type NavContainerProps = {
    useGrid?: boolean;
    menuItems?: MenuItems | null;
    breakingNews?: BannerData;
    countryCode?: string;
};

export default function NavContainer({
    menuItems,
    breakingNews,
    countryCode,
}: NavContainerProps) {
    const trackingFunction = useCallback(
        (eventAction: string, eventLabel: string) => {
            tracker.trackEvent({
                event: "navClick",
                action: eventAction,
                label: eventLabel,
            });
        },
        []
    );

    const bannersTrackingFunction = useCallback(
        (eventAction: string, eventLabel: string) => {
            bannersTracker.trackEvent({
                event: "bannersEvent",
                action: eventAction,
                label: eventLabel,
            });
        },
        []
    );

    return (
        <Nav
            theme={THEMES.DARK}
            user={useNav().user}
            searchClient={useNav().searchClient}
            initializeSignInWithRegUI={useNav().initializeSignInWithRegUI}
            onSignOut={useNav().onSignOut}
            desktopBreakpointClassName={styles.navDesktop}
            {...(menuItems ? { menuItems } : { hideMenu: true })}
            bannerData={breakingNews}
            subscriptionUrl={useNav().subscriptionUrl}
            upgradeUrl={useNav().upgradeUrl}
            trackingFunction={trackingFunction}
            bannersTrackingFunction={bannersTrackingFunction}
            countryCode={countryCode}
        />
    );
}
